import { useEffect } from 'react'
import { type ApplicationInsights } from '@microsoft/applicationinsights-web'
import useApi from '../../api/useApi'
import { useConfiguration } from '../../core/providers/ConfigurationContext'

const toAuthenticatedUserId = (driverId: string): string =>
  driverId.replace(/[,;=| ]+/g, '_')

export const useEnsureDriver = (appInsights: ApplicationInsights): void => {
  const config = useConfiguration()
  const { driverApi } = useApi(config)

  useEffect(() => {
    const ensureDriverExists = async (): Promise<void> => {
      const driver = await driverApi.getDriver()
      if (driver == null) {
        return
      }
      appInsights.setAuthenticatedUserContext(toAuthenticatedUserId(driver.id))
    }

    void ensureDriverExists()
  }, [])
}
